const userKey = '_nscorporate_user'
const INITIAL_STATE = {
    user: JSON.parse(sessionStorage.getItem(userKey)),
    sucesso: false,
    isAuthenticated: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'USER_FETCHED':
            return {...state, user: action.payload, isAuthenticated: true }
        case 'USER_UPDATED':
            return { ...state, user: action.payload, sucesso: action.sucesso }
        default:
            return state
    }
}